// src/components/sections/home/Mission.tsx
import React from 'react';
import { Check } from 'lucide-react';
import { mission, values } from '../../../data/team';

const Mission: React.FC = () => {
  return (
    <section className="py-16 md:py-24">
      <div className="container-wide">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          <div>
            <img 
              src="/assets/images/domov/nase-poslanstvo-image.png" 
              alt="Tradicionalna pridelava bučnega olja" 
              className="rounded-lg shadow-xl w-full h-auto object-cover"
              width={600}
              height={400}
            />
          </div>
          
          <div>
            <div className="mb-8">
              <h6 className="text-secondary font-semibold mb-2">NAŠE POSLANSTVO</h6>
              <h2 className="text-3xl md:text-4xl font-bold text-primary-700 mb-4">
                {mission.title}
              </h2>
              <div className="w-16 h-1 bg-secondary mb-6"></div>
              <p className="text-accent-700">
                {mission.content}
              </p>
            </div>
            
            <div className="space-y-4">
              {values.map((value, index) => (
                <div key={index} className="flex items-start">
                  <div className="flex-shrink-0 bg-primary-50 rounded-full p-1 mr-4">
                    <Check className="h-5 w-5 text-primary-600" />
                  </div>
                  <div>
                    <h4 className="text-lg font-semibold text-primary-700 mb-1">
                      {value.title}
                    </h4>
                    <p className="text-gray-600">
                      {value.description}
                    </p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Mission;